<template>
  <div class="container container-fluid card my-2">
    <!-- EN TODOS LOS COMPONENTES (SPINERS Y ERRORES) --> 
    <div v-if="loading" class="">
      <div class="text-center pt-4">
        <h5>CREAR USUARIO</h5>
      </div> 
      <Loading-Style/>
    </div>

    <div v-if="!loading" class="container">
      <div v-if="errors.length && !mostrarForm">
        <div class="text-center pt-4">
          <h5>CREAR USUARIO</h5>
        </div>
        <p class="alert alert-danger text-center">
          <ul>
            <li v-for="error in errors" :key="error.mensaje">{{ error.mensaje }}</li>
          </ul>
        </p>
      </div>

      <div v-if="mostrarForm" class="text-left pt-2">
        <h5>CREAR USUARIO</h5>
      </div>
      <div class="col-md-12 mt-4 text-center">
        <hr class="custom-hr mb-4" />
      </div>

      <form v-if="mostrarForm" @submit.prevent="formUser">
        <div class="container container-fluid py-4">
          <div class="row">
            <div class="form-group bordered">
              <label for="name" class="form-label text-left">Nombre y Apellido</label>
              <input type="text" class="form-control" id="name" v-model="name" />
            </div>
            <div class="form-group bordered">
              <label for="username" class="form-label text-left">Usuario - para iniciar sesión</label>
              <input type="text" class="form-control" id="username" v-model="username" />
            </div>
            <div class="form-group bordered">
              <label for="email" class="form-label text-left">Email</label>
              <input type="email" class="form-control" id="email" v-model="email" />
            </div>
            <div class="form-group bordered">
              <label for="password" class="form-label text-left">Contraseña</label>
              <input type="password" class="form-control" id="password" v-model="password" autocomplete/>
            </div>
            <div class="form-group bordered">
              <label for="confirmPassword" class="form-label text-left">Confirmar Contraseña</label>
              <input type="password" class="form-control" id="confirmPassword" v-model="confirmPassword" autocomplete/>
            </div>
            <div class="form-group bordered col-md-4 mt-3">
              <label for="roles" class="form-label text-left">Roles</label>
              <select v-model="selectedRole" class="form-control">
                <option value="" disabled>-- Selecciona Rol --</option>
                <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.roleName }}</option>
              </select>
            </div>
          </div>
        </div>
        <hr class="custom-hr my-3" />
        <div class="form-group d-grid gap-2 mt-3">
          <button type="submit" class="btn btn-block btn-custom mb-3">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import apiUsers from '../../../apis/User'
  import { selectRoles } from '../../../Utils/apiUsersSelectorHelpers'
  import { handleError, handleSweetInfo } from '../../../Utils/StatusHandler'
  import { showSpinner, closeSpinner } from '../../../Utils/AlertHandler'
  
  export default {
    name: 'FormCreateUser',

    setup() {
      const router = useRouter();
      const loading = ref(true);
      const mostrarForm = ref(false);
      const errors = ref([]);
      const alert = ref([]);
      const name = ref(null);
      const username = ref('');
      const email = ref('');
      const password = ref('');
      const confirmPassword = ref('');

      const roles = ref([]);
      const selectedRole = ref('');

      const handleErrors = (error) => {
        handleError(error, { errors });
      };
      
      const handleSweetAlert = (info) => {
        handleSweetInfo(info, { alert });
      };

      const cargarDatos = async () => {
        try {
          roles.value = await selectRoles();

          if (roles.value.length == 0) {
            console.error('Error: No se llenó correctamente el selector.');
            mostrarForm.value = false;
          } else {
            mostrarForm.value = true;
          }
        } catch (error) {
          console.error(error);
          handleErrors(error);
          mostrarForm.value = false;
        } finally {
          loading.value = false;
        }
      };


      const formUser = async () => {
        try {
          showSpinner();
          const formData = {
            name: name.value,
            username: username.value,
            email: email.value,
            rol: selectedRole.value,
            password: password.value,
            confirmPassword: confirmPassword.value
          }
          
          const response = await apiUsers.postCreateUser(formData);
  
          if (response) {
            closeSpinner();
            handleSweetAlert(response);
          }
        } catch (error) {
          console.error(error)
          closeSpinner(); 
          handleSweetAlert(error);
        }
      };

      onMounted(cargarDatos);
     
      return {
        loading,
        mostrarForm,
        errors,
        alert,
        name,
        username,
        email,
        password,
        confirmPassword,
        roles,
        selectedRole,
        formUser,
      };
    },
  };
</script>
